var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandColorBscSwap = function SvgBrandColorBscSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#12161C",
    d: "M6.721 11.496a.76.76 0 0 1 .763-.759l1.264.004a.76.76 0 0 1 .76.76v4.78c.142-.042.325-.087.525-.134a.63.63 0 0 0 .488-.616V9.6a.76.76 0 0 1 .76-.76h1.268a.76.76 0 0 1 .76.76v5.504s.318-.129.626-.259a.64.64 0 0 0 .388-.584v-6.56a.76.76 0 0 1 .76-.76h1.266a.76.76 0 0 1 .76.76v5.402c1.097-.796 2.21-1.753 3.093-2.904a1.28 1.28 0 0 0 .195-1.19 8.946 8.946 0 1 0-16.208 7.392 1.13 1.13 0 0 0 1.079.56q.36-.032.893-.093a.633.633 0 0 0 .561-.628z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B90B",
    d: "M6.695 19.162a8.948 8.948 0 0 0 14.19-7.851c-3.269 4.877-9.307 7.157-14.19 7.851"
  })));
};
export { SvgBrandColorBscSwap as ReactComponent };